import { Injectable, inject } from '@angular/core';
import { Firestore, collection, addDoc, DocumentReference, serverTimestamp, query, orderBy, collectionData } from '@angular/fire/firestore';
import { from, Observable } from 'rxjs';
import { Survey } from '../models/survey';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  private firestore = inject(Firestore);
  private readonly COLLECTION_NAME = 'survey';

  saveSurvey(surveyData: Omit<Survey, 'id' | 'createdAt'>): Observable<DocumentReference> {
    const surveysRef = collection(this.firestore, this.COLLECTION_NAME);

    const dataToSave = {
      ...surveyData,
      createdAt: serverTimestamp()
    };
    return from(addDoc(surveysRef, dataToSave));
  }

  getSurveys(): Observable<Survey[]> {
    const surveysRef = collection(this.firestore, this.COLLECTION_NAME);
    const q = query(surveysRef, orderBy('createdAt', 'desc'));
    return collectionData(q, { idField: 'id' }) as Observable<Survey[]>;
  }
}
